import Popup from './popup';
import Tracker from '../../helpers/tracker';
import { EnhanceEcommerce } from '../../helpers/EnhanceEcommerce';
import { getUrlParams } from '../../helpers/handle-url';
import { getHTMLElement, getHTMLElements, getClosestParentElement } from '../../helpers/dom-interact';
import { TrackingData } from '../../helpers/TrackingTypes';

const TestProductPopup = Popup.extend({
	constructor(options = {}) {
		const defaultConfig = {
			opener: '.js-test-product-add-to-wishlist-popup-button, .js-test-product-open-configurator-popup-button',
			popupContent: '#test-product-popup-content',
			popup: '.modal-window',
			content: '.modal-content',
			overlay: '.modal-window-overlay',
			closeBtn: '.modal-window .close-btn, .modal-window .js-back-to-product',
		};

		this.config = { ...defaultConfig, ...options };

		this.trackingCategory = options.trackingCategory;
		this.popupContent = getHTMLElement(document, this.config.popupContent).innerHTML;
		this.elements = Array.from(getHTMLElements(document, this.config.opener));

		this.init();

		this.attachEvents();
	},

	attachEvents() {
		this.elements.forEach((element) => {
			element.addEventListener('click', (event) => {
				this.onButtonClick(event);
			});
		});
	},

	onButtonClick(event) {
		event.preventDefault();
		event.stopPropagation();

		this.open(this.popupContent);
		this.trackButtonClick(event.currentTarget);
	},

	trackButtonClick(element) {
		const isGoToConfiguratorButton = element.classList.contains('js-test-product-open-configurator-popup-button');
		const trackingLabel =
			typeof productJSON !== 'undefined'
				? productJSON.abstractSku
				: getClosestParentElement(element, '.category-item, .PortraitCategoryItem').dataset.sku;
		const trackingAction = isGoToConfiguratorButton
			? TrackingData.ACTION_TEST_PRODUCT_OPEN_CONFIGURATOR
			: TrackingData.ACTION_TEST_PRODUCT_ADD_TO_WISHLIST;
		const customOptions = getUrlParams();

		Tracker.track({
			category: this.trackingCategory,
			action: trackingAction,
			label: trackingLabel,
		});

		if (isGoToConfiguratorButton) {
			EnhanceEcommerce.trackFakeGoToConfiguratorAction(productJSON, customOptions, 'eec-open-configurator');
		}
	},
});

export default TestProductPopup;
